import { LayoutBreakpoints, LayoutElement } from "@entaconsulting/form";
import getElementSize from "./getElementSize";

const findBiggestElement = (
  elements: LayoutElement[],
  insertAt: number,
  rowStart: number,
  rowEnd: number,
  modifieds: Record<string, any>,
  activeBreakpoint: NonNullable<LayoutBreakpoints>
) => {
  let maxSize = 1;
  let biggestElement = null;
  let index = null;

  //recorrer hacia la derecha
  for (let i = insertAt; i <= rowEnd; i++) {
    let element = modifieds[i] ?? elements[i];
    let elementSize = getElementSize(element, activeBreakpoint);
    if (elementSize > maxSize) {
      maxSize = elementSize;
      biggestElement = element;
      index = i;
    }
  }
  //recorrer hacia la izquierda
  for (let i = insertAt - 1; i >= rowStart; i--) {
    let element = modifieds[i] ?? elements[i];
    let elementSize = getElementSize(element, activeBreakpoint);
    if (elementSize > maxSize) {
      maxSize = elementSize;
      biggestElement = element;
      index = i;
    }
  }

  return { element: biggestElement, index };
};
export default findBiggestElement;
